import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PwaInstallService } from './services/pwa-install.service';
import { AppUpdateNotificationService } from './services/app-update-notification.service';
import { NotificationService } from './services/notification.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
    constructor(
        private pwaService: PwaInstallService,
        private appUpdateService: AppUpdateNotificationService,
        private notificationService: NotificationService  // Triggers service initialization
    ){}

    ngOnInit(): void {
        this.pwaService.initialize();
        this.appUpdateService.initialize();
        this.notificationService.setupServiceWorkerEventListener();
    }

    ngOnDestroy(): void {
        this.pwaService.cleanup();
        this.appUpdateService.cleanup();
    }


}
